<div class="no-results">
  <capra-icon icon="illo-new-query-empty-state" width="72px" height="72px" data-test="icon"></capra-icon>
  <h2 class="header" data-test="header">Sorry, the Query succeeded but didn’t return any results</h2>
</div>
